import axios from "axios";
export const SendContactFormDetails = async (contact) => {
  const ContactDetails = {
    'ToName':contact.from_name, 
    'ToEmail':contact.email,
    'MobileNo':contact.mobile,
    'CompanyName':contact.company_name,
    'CompanySize':contact.company_size
    };
    const headers = { 
      'Content-Type': 'application/json; charset=utf-8'
  };
  return await axios
    .post("https://test.megasoftsol.com/EmailAPI/EmailAPI.asmx/SendForm", JSON.stringify(ContactDetails), {headers})
    .then((res) => res.data.d)
    .catch((err) => err); 
};
